module.exports = __webpack_public_path__ + "static/media/tomorrow.c6890f0a.jpg";